import { scheduledRunsApi } from 'apiConnector/scheduledRun/scheduledRuns';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { scheduledRunActions } from 'state/scheduledRuns/actions';
import type { EpicWithThunk } from 'state/state.common';
import { type HttpError, toTypedError } from 'utils/http/httpClient.model';

export function requestScheduledRunOccurrencesEpic(): EpicWithThunk {
  return (actions$, _, { httpClient }) => {
    const { getOccurrences } = scheduledRunsApi(httpClient);

    return actions$.pipe(
      ofType('SCHEDULED_RUN_OCCURRENCES_REQUESTED'),
      mergeMap(({ id, runId, requestId }) =>
        getOccurrences(runId).pipe(
          map(occurrences => scheduledRunActions.occurrencesReceived(id, runId, requestId, occurrences)),
          catchError((error: HttpError) =>
            of(scheduledRunActions.occurrencesFailed(id, runId, requestId, toTypedError('Pricing Runs DIY', error))),
          ),
        ),
      ),
    );
  };
}
